import { BuildingWideChangesContent } from "./content/buildingWideChangesContent";
import { DockingPanel } from "./dockingPanel";

export class BuildingWideChangesDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement, onVisibilityChanged: (visibility: boolean) => void) {
        this._visible = false;

        const component = <BuildingWideChangesContent />;

        const panelWidth = 350;
        const panelHeight = 200;

        this.panel = new DockingPanel(
            container, "dextall-building-wide-changes-docking-panel", "Building Wide Changes", component,
            {
                style: {
                    resize: "none",
                },
                dimensionsControl: {
                    preventOverlapsWithViewerToolbar: true,
                    widthDimensionControl: { value: panelWidth, minValue: panelWidth },
                    heightDimensionControl: { value: panelHeight, minValue: panelHeight },
                    rightOffset: 4,
                    topOffset: 4,
                },
            });

        this.panel.addVisibilityListener((x: boolean) => {
            this._visible = x;
            onVisibilityChanged(x);
        });
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
